import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc/client";

export const useListPracticeTests = (source: {
  studySetId?: string;
  folderId?: string;
}) => {
  const trpc = useTRPC();
  return useQuery(trpc.practiceTests.list.queryOptions(source));
};
